import { ActForm, SignatureState, User } from '@builddocs/data-management'
import { AOSRType, SecondaryActType, signAct } from '@builddocs/filestore-api'
import { signSecondaryAct } from '@builddocs/filestore-api'
import { toast } from 'react-toastify'

type SigningActType = {
  act: AOSRType | SecondaryActType
  user: User
  signedHash: string
  actRegistryBase64signature: string
  keyIssuer: string
  imprint: string
  facePhoto: string
  keySerialNumber: string
  signerName: string
  withPoa?: boolean
  poaId?: string | null
  poaDateStart?: string | null
  poaDateEnd?: string | null
  refreshAct: () => void
  onSuccess?: () => void
  onError?: (error: Error) => void
}

export const sendSignedData = async ({
  act,
  user,
  signedHash,
  actRegistryBase64signature,
  keyIssuer,
  imprint,
  facePhoto,
  keySerialNumber,
  refreshAct,
  signerName,
  poaId,
  withPoa,
  poaDateStart,
  poaDateEnd,
}: SigningActType): Promise<boolean> => {
  const isAosr = act.actType === ActForm.AOSR

  try {
    if (isAosr) {
      await signAct({
        documentId: act.id,
        employmentId: user.employment.employmentId,
        signatureState: SignatureState.SIGNED,
        base64signature: signedHash,
        actRegistryBase64signature,
        keyIssuer,
        imprint,
        name: signerName,
        faceId: {
          faceImage: facePhoto,
          keySerialNumber,
        },
        poaId,
        withPoa,
        poaDateStart,
        poaDateEnd,
      })
    } else {
      await signSecondaryAct({
        documentId: act.id,
        employmentId: user.employment.employmentId,
        signatureState: SignatureState.SIGNED,
        base64signature: signedHash,
        keyIssuer,
        imprint,
        name: signerName,
        faceId: {
          faceImage: facePhoto,
          keySerialNumber,
        },
        poaId,
        withPoa,
        poaDateStart,
        poaDateEnd,
      })
    }

    refreshAct()
    toast.success('Подписано')
    return true
  } catch (error) {
    toast.error('Не удалось подписать')
    return false
  }
}
